import { CertificateForm } from '../../forms/certificateForms/certificate.forms';

export const Certificates = () => {
  return <CertificateForm />;
};
